import { render, staticRenderFns } from "./MyCoursesSidebarSwitch.vue?vue&type=template&id=038d3af0&"
import script from "./MyCoursesSidebarSwitch.vue?vue&type=script&lang=js&"
export * from "./MyCoursesSidebarSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports